module.exports = __webpack_public_path__ + "static/media/retirada-icon.d68999e2.svg";